import { addBookmark } from '../services/bookmarkService';

const BOOKMARKS_STORAGE_KEY = 'bloomwik_bookmarks';
const LEGACY_BOOKMARKS_KEY = 'blogify_bookmarks';

function readLocalBookmarkIds() {
  try {
    const stored =
      localStorage.getItem(BOOKMARKS_STORAGE_KEY) ||
      localStorage.getItem(LEGACY_BOOKMARKS_KEY);
    if (!stored) return [];
    const items = JSON.parse(stored);
    if (!Array.isArray(items)) return [];
    return items
      .map((item) => item._id || item.id || item.article?._id || item.article?.id)
      .filter(Boolean);
  } catch {
    return [];
  }
}

function clearLocalBookmarks() {
  try {
    localStorage.removeItem(BOOKMARKS_STORAGE_KEY);
    localStorage.removeItem(LEGACY_BOOKMARKS_KEY);
  } catch {
    /* ignore */
  }
}

/** Push localStorage bookmarks to the server after login/register. */
export async function syncLocalBookmarksToServer() {
  const ids = [...new Set(readLocalBookmarkIds())];
  if (!ids.length) return { synced: 0 };

  let synced = 0;
  for (const articleId of ids) {
    try {
      await addBookmark(articleId);
      synced += 1;
    } catch {
      /* duplicate or missing article — skip */
    }
  }

  if (synced > 0) {
    clearLocalBookmarks();
  }

  return { synced };
}
